import { RoutePath } from '@constants/routes';

export const PATH_MAP = {
    [RoutePath.Login]: 'login',
    [RoutePath.Signup]: 'signup',
    [RoutePath.ResetPassword]: 'resetPassword',
    [RoutePath.ForgotPassword]: 'forgotPassword',
    [RoutePath.VerifyEmail]: 'verifyEmail',
    [RoutePath.Error]: 'error',
    // INFO: In AppLayout paths
    [RoutePath.Home]: 'home',
    // '/surveys/sent': 'sent',
    [RoutePath.SurveysResponses]: 'responses',
    [RoutePath.SurveysTemplates]: 'templates',
    [RoutePath.SurveysAnalyticsConversion]: 'analytics',
    [RoutePath.SurveysAnalyticsResponses]: 'analytics',
    [RoutePath.ReviewsManage]: 'reviewsManage',
    [RoutePath.ReviewsAutomationAutoReplies]: 'reviewsAutomation',
    [RoutePath.ReviewsAutomationReplyTemplates]: 'reviewsAutomation',
    [RoutePath.ReviewsWidgets]: 'reviewsWidgets',
    [RoutePath.ReviewsAnalyticsReviews]: 'analytics',
    [RoutePath.ReviewsAnalyticsKeywords]: 'analytics',
    [RoutePath.MessagingInbox]: 'messagingInbox',
    // '/messaging/templates': 'messagingTemplates',
    [RoutePath.MessagingPulseAIKnowledgeBase]: 'pulseAI',
    [RoutePath.MessagingPulseAIAgents]: 'pulseAI',
    [RoutePath.MessagingAnalytics]: 'analytics',
    [RoutePath.Microsites]: 'microsites',
    [RoutePath.AccountSettingsProfile]: 'settingsProfile',
    [RoutePath.AccountSettingsGeneral]: 'settingsGeneral',
    [RoutePath.AccountSettingsCompanies]: 'settingsCompanies',
    [RoutePath.AccountSettingsChannels]: 'settingsChannels',
    [RoutePath.AccountSettingsUsers]: 'settingsUsers',
    [RoutePath.AccountSettingsIntegrations]: 'settingsIntegrations',
    [RoutePath.AccountSettingsBrands]: 'settingsBrands',
    [RoutePath.Onboarding]: 'onboarding',
    [RoutePath.SocialPosts]: 'socialPosts',
    [RoutePath.SocialAnalytics]: 'analytics',
    //'/orders': 'ordersIfood',
    [RoutePath.Campaigns]: 'campaigns',
    [RoutePath.CampaignsAutomated]: 'campaignsAutomated',
    [RoutePath.CampaignsOneTime]: 'campaignsOneTime',
    [RoutePath.Contacts]: 'contacts',
    [RoutePath.PresenceProfiles]: 'presenceProfiles',
    [RoutePath.PresenceMedia]: 'presenceMedia',
    [RoutePath.PresenceAnalytics]: 'analytics',
    [RoutePath.Coupons]: 'coupons',
};
